import { ReactNode } from 'react';
import Link from 'next/link';

import { getRouteUrl } from '@utils/urls';

import { PRODUCT, SHOP_EVENT_PRODUCT } from '@common/routes';
import { Languages } from '@common/constants/languages';

import { Pill } from './SizeLink.styled';

interface SizeLinkProps {
  active: boolean;
  disabled: boolean;
  children: ReactNode;
  slug: string;
  articleNr: string;
  locale: Languages;
  route: typeof PRODUCT | typeof SHOP_EVENT_PRODUCT;
}

const SizeLink = ({
  active,
  disabled,
  children,
  slug,
  articleNr: id,
  locale,
  route,
}: SizeLinkProps) =>
  disabled ? (
    <Pill $disabled>{children}</Pill>
  ) : (
    <Link
      href={{
        pathname: route,
        query: { id, slug },
      }}
      as={getRouteUrl(locale, route, { id, slug })}
      scroll={false}
    >
      <Pill $active={active}>{children}</Pill>
    </Link>
  );

export default SizeLink;
